import React from 'react';
import Page from '../../components/Page';
import { AccountSettingsDetails } from '../../sections/client-zs/AccountSettingsDetails';

const AccountSettings = () => (
  <Page title="Ustawienia Konta">
    <AccountSettingsDetails />
  </Page>
);

export default AccountSettings;
